import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Table, UncontrolledPopover, PopoverBody} from 'reactstrap';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import './BulkConsentRequestsList.css';
import _ from 'lodash';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import RemoveBulkConsentRequestModal from "../removeBulkConsetRequestModal/RemoveBulkConsentRequestModal.container";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
// import {CURRENCIES} from "../../../constants/constants";
// import moment from "moment";

const UNSUFFICIENT_BALANCE = 'UNSUFFICIENT_BALANCE';

class BulkConsentRequestsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            bulkToRemove: null
        }
    }

    // componentWillMount() {
        // this.props.onMount();
    // }

    render() {
        return (
            <div className='bulk-consents-requests-jobs-list-container'>
                <FormWrapper showSuccessAlert={false}>
                    <h4 className="page-label">
                        {_.get(this.props.translation, 'bulk_jobs_list.bulk_consent_requests_label')}
                    </h4>
                    {this.renderDepartment()}
                    {this.renderContent()}
                    <RemoveBulkConsentRequestModal data={this.state.bulkToRemove}
                                                   onCancelRemoving={this.props.onCancelRemoving}/>
                </FormWrapper>
            </div>
        );
    }

    renderDepartment = () => {
        if (this.props.groupName) {
            return (
                <div className="department-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.department_label)}:</h6>
                    <div>{this.props.groupName}</div>
                </div>
            )
        }
    };

    renderContent() {
        if ((this.props.loading && (_.isNil(this.props.data) || _.isEmpty(this.props.data))) /*|| _.isNil(this.props.balance) || _.isNil(this.props.consentRequestFee) || _.isNil(this.props.paidTillDate)*/) {
            return (
                <div className="bulk-jobs-list-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || _.isEmpty(this.props.data)) {
            return (
                <div className="bulk-jobs-list-message-container">
                    <h5>{_.get(this.props.translation, 'bulk_jobs_list.no_bulk_consents_data_label')}</h5>
                </div>
            );
        }
        return [
            this.renderWarning(),
            this.renderTable()
        ]
    }

    renderWarning = () => {
        //TODO: add money conversion if balance and pricing ara in different currencies (conversion is now available only for SysAdmin)
        // if (this.props.balance.amount < this.props.consentRequestFee.amount || moment(this.props.paidTillDate).isBefore(moment())) {
        //     return (
        //         <div className="consent-requests-jobs-status-message-container"  key="consent-requests-jobs-status-message">
        //             <h6>{_.get(this.props.translation, 'request_credentials_verification.request_unavailable_alert')}</h6>
        //         </div>
        //     )
        // }
    }

    renderTable() {
        return (
            <Table className='consent-requests-jobs-data-table' key="consent-requests-jobs-data-table">
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'consents.job_title_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_jobs_list.requestor_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_jobs_list.created_at_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_jobs_list.created_requests_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_jobs_list.processed_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_jobs_list.status_label')}</th>
                    <th/>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderJobsData()}
                </tbody>
            </Table>
        );
    }

    renderJobsData() {
        //TODO: add money conversion if balance and pricing ara in different currencies (conversion is now available only for SysAdmin)
        // let isDisabledRequestFlush = this.props.balance.amount < this.props.consentRequestFee.amount || moment(this.props.paidTillDate).isBefore(moment());
        return _.map(this.props.data, (jobData) => (
            <tr key={jobData.id}
                className="consent-requests-jobs-data-row">
                <td className='job-title-td'
                    data-th={_.get(this.props.translation, 'consents.job_title_label') + ":"}>
                    {jobData.jobTitle}
                    {jobData.jobReference ? <div className="job-reference">({jobData.jobReference})</div> : null}
                </td>
                <td className='requester-td'
                    data-th={_.get(this.props.translation, 'bulk_jobs_list.requestor_label') + ":"}>
                    <a href={"mailto:" + jobData.requesterEmail}>{jobData.requesterEmail}</a>
                </td>
                <td className='created-at-td'
                    data-th={_.get(this.props.translation, 'bulk_jobs_list.created_at_label') + ":"}>{jobData.createdAt}</td>
                <td className='created-requests-td'
                    data-th={_.get(this.props.translation, 'bulk_jobs_list.created_requests_label') + ":"}>
                    {jobData.createdConsentRequestsCount}
                </td>
                <td className='processed-td'
                    data-th={_.get(this.props.translation, 'bulk_jobs_list.processed_label') + ":"}>
                    {jobData.processedPersent}% ({jobData.processedEntriesCount}/{jobData.totalEntriesCount})
                </td>
                <td className='status-td'
                    data-th={_.get(this.props.translation, 'bulk_jobs_list.status_label') + ":"}>{this.getStatus(jobData)}</td>
                <td className='control-cell flush-icon-container'>
                    {jobData.error && jobData.error === UNSUFFICIENT_BALANCE /*&& !isDisabledRequestFlush*/ ?
                        <IconContainer
                            className="flush-icon"
                            icon='play_circle_outline'
                            title={_.get(this.props.translation, 'bulk_jobs_list.flush_remaining_label')}
                            onClick={this.handleFlushRemainingButtonClick(jobData.id)}/> : null}
                </td>
                <td className='control-cell bulk-controls'>
                    {jobData.finished ? (
                        <IconContainer
                            className="job-remove-icon"
                            icon='trash'
                            title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                            onClick={this.handleRemoveBulk(jobData)}
                        />
                    ) : null}
                </td>
            </tr>
        ));
    }

    getStatus = (jobData) => {
        if (!jobData.finished) {
            return (
                <span
                    className='in-progress-label'>{_.get(this.props.translation, 'bulk_jobs_list.in_progress_label')}</span>
            )
        } else {
            if (jobData.error) {
                return (
                    <div className="status-container">
                        <span className='error-label'>
                            {_.get(this.props.translation, 'bulk_jobs_list.error_label')}
                        </span>
                        <span
                            id={'error-info-icon-container' + jobData.id}
                            className='error-info-icon-container'
                        >
                            <IconContainer
                                className="error-info-icon"
                                icon='question_mark'
                                title={_.get(this.props.translation, sharedLabelsPath.about_label)}
                            />
                        </span>
                        <UncontrolledPopover
                            placement="bottom"
                            trigger="legacy" 
                            target={'error-info-icon-container' + jobData.id}
                        >
                            <PopoverBody>
                                {jobData.error === UNSUFFICIENT_BALANCE ? this.getUnsufficientBalanceErrorAlert(jobData) :
                                    _.get(this.props.translation, sharedLabelsPath.errors)[jobData.error]}
                            </PopoverBody>
                        </UncontrolledPopover>
                    </div>
                )
            } else {
                return (
                    <span
                        className='finished-label'>{_.get(this.props.translation, 'bulk_jobs_list.finished_label')}</span>
                )
            }
        }
    };

    getUnsufficientBalanceErrorAlert = (jobData) => {
        // if (_.isNil(this.props.balance) || _.isNil(this.props.consentRequestFee)) {
        //     return;
        // }

        //TODO: add money conversion if balance and pricing ara in different currencies (conversion is now available only for SysAdmin)
        // let amount = this.props.consentRequestFee.amount * (jobData.totalEntriesCount - jobData.processedEntriesCount) - this.props.balance.amount;

        return _.get(this.props.translation, 'bulk_jobs_list.insufficient_balance_error_alert_part_1')
            .replace('{processed}', jobData.processedEntriesCount)
            .replace('{total}', jobData.totalEntriesCount);
            // + _.get(this.props.translation, 'bulk_jobs_list.insufficient_balance_error_alert_part_2')
            // .replace('{amount}', amount + CURRENCIES[this.props.balance.currency]);
    };

    componentDidMount() {
        this.props.onLoadJobs();
    }

    componentWillReceiveProps(nextProps) {
        this.fetchJobsListTimeout(nextProps.data);
    }

    componentWillUpdate(nextProps) {
        if (!_.isNil(nextProps.groupId) && nextProps.groupId !== this.props.groupId) {
            this.props.onLoadJobs();
        }
    }

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
    }

    fetchJobsListTimeout(jobsData) {
        if (!_.isEmpty(jobsData) && _.some(jobsData, job => !job.finished) && _.isNil(this.timeout)) {
            this.timeout = setTimeout(
                () => {
                    this.props.onLoadJobs();
                    this.timeout = null;
                },
                5000
            );
        }
    }

    handleRemoveBulk = (jobData) => () => {
        this.props.onRemoveBulk();
        this.setState({bulkToRemove: jobData});
    };

    handleFlushRemainingButtonClick = (id) => () => {
        this.props.onResumeBulk(id);
    };
}


BulkConsentRequestsList.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    translation: PropTypes.object,
    // balance: PropTypes.object,
    // consentRequestFee: PropTypes.object,
    // paidTillDate: PropTypes.string,
    // onMount: PropTypes.func,
    onLoadJobs: PropTypes.func,
    onRemoveBulk: PropTypes.func,
    onCancelRemoving: PropTypes.func,
    onResumeBulk: PropTypes.func
};

export default BulkConsentRequestsList;



// WEBPACK FOOTER //
// ./src/components/consentManagement/bulkConsentRequestsList/BulkConsentRequestsList.js